// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"ffe6e98d","267":"4214c5b7","283":"bb3ab0b3","286":"1af401ae","445":"02b4da9d","509":"aa42d57f","661":"083bd554","686":"2c52b3f0","820":"fa5241d3","890":"874398cc","892":"d81b9402","926":"7a766b4f"}[chunkId] + ".chunk.js";
};